var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 152.048,
    height: 32.128,
    viewBox: "0 0 152.048 32.128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_76",
    "data-name": "Raggruppa 76",
    transform: "translate(-21.5 -145.266)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header",
    transform: "translate(21.5 145.266)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5",
    "data-name": "Raggruppa 5",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4",
    "data-name": "Raggruppa 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1",
    "data-name": "Raggruppa 1",
    transform: "translate(25.385 26.292)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1",
    "data-name": "Tracciato 1",
    d: "M147.888,147.973a4.11,4.11,0,0,1,2.061.562l-.424.582a3.285,3.285,0,0,0-1.637-.429,2.2,2.2,0,1,0,0,4.405,2.814,2.814,0,0,0,1.378-.317v-1.461h-1.554v-.623h2.341v2.493a3.993,3.993,0,0,1-2.185.613,2.917,2.917,0,1,1,.021-5.826",
    transform: "translate(-144.812 -147.973)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_2",
    "data-name": "Tracciato 2",
    d: "M173.92,148.435h2.6c1.595,0,2.145.889,2.145,1.748a1.6,1.6,0,0,1-1.223,1.595l1.244,2.227h-.922l-1.119-2.1h-1.865v2.1h-.859Zm2.568,2.8c.952,0,1.315-.532,1.315-1.052,0-.542-.352-1.053-1.3-1.053h-1.72v2.1Z",
    transform: "translate(-165.561 -148.302)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3",
    "data-name": "Tracciato 3",
    d: "M200.789,148.435h.86v3.444a1.591,1.591,0,0,0,3.18,0v-3.444h.87v3.444a2.464,2.464,0,0,1-4.91,0Z",
    transform: "translate(-184.714 -148.302)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4",
    "data-name": "Tracciato 4",
    d: "M228.886,148.435h2.527c1.585,0,2.134.889,2.134,1.748,0,.828-.559,1.747-2.144,1.747h-1.658v2.075h-.86Zm2.5,2.8c.953,0,1.294-.521,1.294-1.052s-.331-1.053-1.294-1.053h-1.637v2.1Z",
    transform: "translate(-204.742 -148.302)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_5",
    "data-name": "Tracciato 5",
    d: "M255.577,148.435H258.1c1.585,0,2.134.889,2.134,1.748,0,.828-.56,1.747-2.144,1.747h-1.658v2.075h-.86Zm2.5,2.8c.953,0,1.3-.521,1.3-1.052s-.331-1.053-1.3-1.053h-1.637v2.1Z",
    transform: "translate(-223.768 -148.302)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_6",
    "data-name": "Tracciato 6",
    d: "M284.047,147.973a2.914,2.914,0,1,1-3,2.882,2.883,2.883,0,0,1,3-2.882m0,5.11a2.2,2.2,0,1,0-2.133-2.228,2.11,2.11,0,0,0,2.133,2.228",
    transform: "translate(-241.921 -147.973)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_7",
    "data-name": "Tracciato 7",
    d: "M326.6,148.435h.88l2.114,2.78,2.123-2.78h.86v5.57h-.839V149.59L329.58,152.4l-2.155-2.79v4.394H326.6Z",
    transform: "translate(-274.393 -148.303)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8",
    "data-name": "Tracciato 8",
    d: "M358.662,148.435h4.257v.705h-3.4v1.707h3.046v.654h-3.046v1.8h3.439v.7h-4.3Z",
    transform: "translate(-297.25 -148.303)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9",
    "data-name": "Tracciato 9",
    d: "M384.054,148.435h1.833c2.124,0,3.253,1.032,3.253,2.719,0,1.778-1.057,2.851-3.253,2.851h-1.833Zm1.865,4.875c1.616,0,2.361-.808,2.361-2.167,0-1.257-.8-2.013-2.361-2.013h-1.005v4.18Z",
    transform: "translate(-315.35 -148.302)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1",
    "data-name": "Rettangolo 1",
    width: 0.86,
    height: 5.57,
    transform: "translate(76.721 0.133)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_10",
    "data-name": "Tracciato 10",
    d: "M428.176,147.973a2.914,2.914,0,1,1-3,2.882,2.883,2.883,0,0,1,3-2.882m0,5.11a2.2,2.2,0,1,0-2.134-2.228,2.11,2.11,0,0,0,2.134,2.228",
    transform: "translate(-344.66 -147.973)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_11",
    "data-name": "Tracciato 11",
    d: "M456.3,148.435h2.476c1.409,0,2.03.633,2.03,1.462a1.262,1.262,0,0,1-.89,1.226,1.33,1.33,0,0,1,1.149,1.3c0,1.022-.859,1.584-2.124,1.584H456.3Zm2.455,2.443c.839,0,1.212-.357,1.212-.9s-.374-.879-1.212-.879h-1.595v1.778Zm.186,2.463c.746,0,1.254-.327,1.254-.951s-.508-.91-1.254-.91h-1.781v1.86Z",
    transform: "translate(-366.85 -148.302)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_12",
    "data-name": "Tracciato 12",
    d: "M483.2,148.435h.974l2.372,5.57h-.923l-.559-1.37h-2.755l-.559,1.37h-.922Zm-.622,3.546h2.217l-1.1-2.688h-.021Z",
    transform: "translate(-384.333 -148.302)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_13",
    "data-name": "Tracciato 13",
    d: "M510.076,148.435h.84l3.221,4.293v-4.293h.829v5.57h-.839l-3.222-4.292v4.292h-.828Z",
    transform: "translate(-405.182 -148.303)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_14",
    "data-name": "Tracciato 14",
    d: "M540.382,147.973a3.485,3.485,0,0,1,2.051.644l-.445.582a2.711,2.711,0,0,0-1.585-.511,2.061,2.061,0,0,0-2.2,2.136,2.112,2.112,0,0,0,2.2,2.269,2.4,2.4,0,0,0,1.668-.613l.508.531a3.22,3.22,0,0,1-2.2.787,2.851,2.851,0,0,1-3.034-2.974,2.818,2.818,0,0,1,3.034-2.851",
    transform: "translate(-424.622 -147.973)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_15",
    "data-name": "Tracciato 15",
    d: "M565.9,148.435h.974l2.371,5.57h-.922l-.559-1.37h-2.756l-.559,1.37h-.922Zm-.621,3.546H567.5l-1.1-2.688h-.021Z",
    transform: "translate(-443.287 -148.302)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2",
    "data-name": "Raggruppa 2",
    transform: "translate(23.779 0.221)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_16",
    "data-name": "Tracciato 16",
    d: "M155.509,75.328a10.149,10.149,0,0,1-16.29-8.015,10.179,10.179,0,0,1,16.29-7.987.439.439,0,0,1,.115.575l-1.781,2.73a.425.425,0,0,1-.6.115,6.283,6.283,0,0,0-3.879-1.408,5.941,5.941,0,0,0-5.717,5.976,5.878,5.878,0,0,0,5.717,6.033,6.005,6.005,0,0,0,3.907-1.379.418.418,0,0,1,.574.144l1.81,2.643A.454.454,0,0,1,155.509,75.328Z",
    transform: "translate(-139.219 -57.257)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_17",
    "data-name": "Tracciato 17",
    d: "M210.153,77.3a10.058,10.058,0,1,1,10.285-10.027A10.027,10.027,0,0,1,210.153,77.3Zm0-16.06a6.006,6.006,0,1,0,5.89,6.033A5.984,5.984,0,0,0,210.153,61.236Z",
    transform: "translate(-182.431 -57.185)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_18",
    "data-name": "Tracciato 18",
    d: "M299.39,77.751h-3.276a.442.442,0,0,1-.431-.431V65.972l-3.907,6.694c-.086.172-.2.431-.373.431h-2.787c-.172,0-.316-.258-.4-.431l-3.907-6.694V77.32a.442.442,0,0,1-.431.431H280.6a.442.442,0,0,1-.431-.431v-18.7a.442.442,0,0,1,.431-.431h3.562c.23,0,.316.229.431.431L290,67.81l5.4-9.193c.115-.2.2-.431.431-.431h3.562a.442.442,0,0,1,.431.431v18.7A.442.442,0,0,1,299.39,77.751Z",
    transform: "translate(-239.693 -57.899)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_19",
    "data-name": "Tracciato 19",
    d: "M372.22,71.918h-4.74v5.4a.424.424,0,0,1-.431.431H363.63a.442.442,0,0,1-.431-.431v-18.7a.442.442,0,0,1,.431-.431h8.59a6.868,6.868,0,0,1,0,13.732Zm-.948-9.969H367.48v6.206h3.792c1.724,0,3.275-.862,3.275-3.1S373,61.949,371.272,61.949Z",
    transform: "translate(-298.878 -57.899)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_20",
    "data-name": "Tracciato 20",
    d: "M432.039,77.536h-3.764c-.259,0-.374-.23-.431-.46l-1.12-3.476H420.03l-1.12,3.476c-.087.23-.2.46-.46.46h-3.678a.389.389,0,0,1-.345-.575l6.809-18.617c.086-.2.173-.46.431-.46h3.5c.259,0,.374.258.431.46l6.751,18.7A.35.35,0,0,1,432.039,77.536Zm-8.648-14.193-2.155,6.579h4.281Z",
    transform: "translate(-335.369 -57.684)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_21",
    "data-name": "Tracciato 21",
    d: "M487.736,77.439a10.536,10.536,0,0,1-6.751-2.212.39.39,0,0,1-.086-.575l1.953-2.5a.39.39,0,0,1,.575-.086,6.366,6.366,0,0,0,4.281,1.522c2.758,0,2.959-1.609,2.959-2.1,0-1.753-2.844-2.011-4.683-2.7C483,67.7,480.64,66.435,480.64,62.758c0-3.074,2.643-5.372,7.441-5.372a11.248,11.248,0,0,1,5.861,1.724.421.421,0,0,1,.115.6l-1.724,2.614a.46.46,0,0,1-.6.144,7.081,7.081,0,0,0-3.706-1.207c-3.074,0-2.93,1.178-2.93,1.494-.057,1.58,3.074,2.1,5.8,3.074,2.672.948,4.31,2.585,4.31,5.66C495.206,74.968,492.19,77.439,487.736,77.439Z",
    transform: "translate(-382.593 -57.328)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_22",
    "data-name": "Tracciato 22",
    d: "M542.255,77.439a10.535,10.535,0,0,1-6.751-2.212.391.391,0,0,1-.087-.575l1.954-2.5a.39.39,0,0,1,.574-.086,6.368,6.368,0,0,0,4.281,1.522c2.758,0,2.959-1.609,2.959-2.1,0-1.753-2.845-2.011-4.683-2.7-2.988-1.092-5.344-2.356-5.344-6.034,0-3.074,2.643-5.372,7.441-5.372a11.247,11.247,0,0,1,5.861,1.724.42.42,0,0,1,.115.6l-1.724,2.614a.46.46,0,0,1-.6.144,7.083,7.083,0,0,0-3.707-1.207c-3.073,0-2.93,1.178-2.93,1.494-.057,1.58,3.074,2.1,5.8,3.074,2.672.948,4.309,2.585,4.309,5.66C549.725,74.968,546.708,77.439,542.255,77.439Z",
    transform: "translate(-421.456 -57.328)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3",
    "data-name": "Raggruppa 3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2",
    "data-name": "Rettangolo 2",
    width: 16.201,
    height: 31.995,
    fill: "#d9000d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_23",
    "data-name": "Tracciato 23",
    d: "M65.342,125.511a5.127,5.127,0,1,0,5.127-5.184,5.161,5.161,0,0,0-5.127,5.184m-.575,0a5.7,5.7,0,1,1,5.7,5.761,5.732,5.732,0,0,1-5.7-5.761",
    transform: "translate(-62.369 -101.563)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_24",
    "data-name": "Tracciato 24",
    d: "M72.807,72.339a3.441,3.441,0,0,1,5.732-2.607l-.384.425a2.858,2.858,0,0,0-1.9-.725,2.9,2.9,0,0,0,0,5.807,2.844,2.844,0,0,0,2.169-1l0,0,.433.374a3.427,3.427,0,0,1-2.6,1.2,3.467,3.467,0,0,1-3.446-3.48",
    transform: "translate(-68.1 -65.285)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_3",
    "data-name": "Rettangolo 3",
    width: 0.575,
    height: 19.2,
    transform: "translate(7.892 2.87)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_4",
    "data-name": "Rettangolo 4",
    width: 10.298,
    height: 0.574,
    transform: "translate(2.871 21.811)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_25",
    "data-name": "Tracciato 25",
    d: "M66.353,95.205l5.04-10.458.518.252-5.04,10.458Z",
    transform: "translate(-63.499 -76.612)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_26",
    "data-name": "Tracciato 26",
    d: "M84,84.432l.518-.25,5.041,10.459-.515.25Z",
    transform: "translate(-76.077 -76.209)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_27",
    "data-name": "Tracciato 27",
    d: "M83.855,138.685a.643.643,0,1,1-.643-.643.642.642,0,0,1,.643.643",
    transform: "translate(-75.06 -114.601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_5",
    "data-name": "Rettangolo 5",
    width: 0.574,
    height: 0.879,
    transform: "translate(7.228 2.803) rotate(-52.541)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_28",
    "data-name": "Tracciato 28",
    d: "M84.108,65.123l.7-.533.353.456-.7.534Z",
    transform: "translate(-76.156 -62.243)",
    fill: "#fff"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1497f6b7a05fd38c2373a880e6ec10ee.svg";
export { ForwardRef as ReactComponent };